import { c as _c } from "react/compiler-runtime";
import { TableBody, TableCell, TableRow } from '../components';
import { Skeleton } from '../components/Skeleton';
import type { ColumnDef } from '@tanstack/react-table';
export interface DataTableBodySkeletonProps<TRow = unknown> {
  /**
   * Number of columns to render skeleton cells for.
   * Should match the number of columns in the actual table.
   * @deprecated Use `columns` prop instead for better alignment support
   */
  columnCount?: number;
  /**
   * Column definitions to extract styling information (alignment, width, etc.)
   * When provided, skeleton cells will match the column styles.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns?: ColumnDef<TRow, any>[];
  /**
   * Number of rows to render.
   * @default 20
   */
  rowCount?: number;
  /**
   * Whether to apply inset padding to cells (defaults to true)
   */
  inset?: boolean;
}

/**
 * Renders skeleton loading state for the body of a DataTable.
 * This component only renders the tbody with skeleton rows,
 * allowing the table header and pagination to be rendered separately.
 */
const DataTableBodySkeleton = t0 => {
  const $ = _c(9);
  const {
    columnCount,
    columns,
    rowCount: t1,
    inset: t2
  } = t0;
  const rowCount = t1 === undefined ? 20 : t1;
  const inset = t2 === undefined ? true : t2;
  let t3;
  if ($[0] !== rowCount) {
    t3 = Array.from({
      length: rowCount
    }, _temp);
    $[0] = rowCount;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const rows = t3;
  const numColumns = columns?.length ?? columnCount ?? 0;
  let t4;
  if ($[2] !== numColumns) {
    t4 = Array.from({
      length: numColumns
    }, _temp2);
    $[2] = numColumns;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const columnIndices = t4;
  let t5;
  if ($[4] !== columnIndices || $[5] !== columns || $[6] !== inset || $[7] !== rows) {
    t5 = <TableBody>{rows.map(rowIndex => <TableRow key={`skeleton-row-${rowIndex}`}>{columnIndices.map(colIndex => {
          const column = columns?.[colIndex];
          const columnStyle = column?.meta?.style;
          const textAlign = columnStyle?.textAlign;
          return <TableCell inset={inset} key={`skeleton-cell-${rowIndex}-${colIndex}`} style={columnStyle}><Skeleton className={textAlign === "right" ? "ml-auto" : textAlign === "center" ? "mx-auto" : ""} width="60%" /></TableCell>;
        })}</TableRow>)}</TableBody>;
    $[4] = columnIndices;
    $[5] = columns;
    $[6] = inset;
    $[7] = rows;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export default DataTableBodySkeleton;
function _temp(_, i) {
  return i;
}
function _temp2(__0, i_0) {
  return i_0;
}